<template>
  <div class="content">
    <!-- <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">Paginated Tables</h2>
    </div> -->
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">Abonos</h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <el-select
                  class="select-success mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-success"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div>
                  <base-input>
                    <el-input
                      type="search"
                      class="mb-3 search-input"
                      color="success"
                      clearable
                      prefix-icon="el-icon-search"
                      placeholder="Pesquisar abono"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </base-input>
                </div>
                <div>
                  <base-button
                    type="success"
                    class="animation-on-hover"
                    style="margin: 0px 5px 0px 5px;"
                    @click="mostrarDialog('Cadastrar')"
                    >Cadastrar Tipo de Abono</base-button
                  >
                </div>
              </div>
            </div>
            <el-table :data="queriedData">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column :min-width="135" align="right" label="Ações">
                <div slot-scope="props">
                  <base-button
                    @click="mostrarDialog('Alterar', props.row)"
                    class="edit btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
            <modal :show.sync="dialogTipoAbono">
              <template slot="header">
                <h4 class="modal-title" id="exampleModalLabel">
                  {{ tipo }}
                </h4>
              </template>
              <div class="row">
                <div class="col-md-12 pr-md-1 text-left">
                  <base-input
                    label="Descrição"
                    placeholder="Descrição"
                    v-model="descricao"
                    :class="erros.descricao === true ? 'has-danger' : ''"
                  >
                  </base-input>
                </div>
                <div class="col-md-12 pr-md-1 text-left">
                  <base-checkbox v-model="ativo" class="col-12" name="preassi1">
                    Ativo?
                  </base-checkbox>
                </div>
              </div>
              <template slot="footer">
                <div class="w-100 d-flex justify-content-end">
                  <base-button
                    type="success"
                    @click="
                      tipo === 'Alterar' ? editarAbono() : cadastrarAbono()
                    "
                    >Salvar</base-button
                  >
                </div>
              </template>
            </modal>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="font-weight-normal">
                Mostrando de {{ from + 1 }} a {{ to }} no total de
                {{ total }} abonos.
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import users from "../pages/Tables/users.js";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import NotificationHorarioLimite from "./Notifications/NotificationHorarioLimite.vue";
import Modal from "@/components/Modal.vue";
import moment from "moment";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    Modal,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      tipo: "",
      descricao: "",
      ativo: true,
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      isLoading: false,
      dialogTipoAbono: false,
      searchQuery: "",
      propsToSearch: ["descricao"],
      tableColumns: [
        {
          prop: "descricao",
          label: "Descrição",
          minWidth: 300,
        },
        {
          prop: "dt_criacao",
          label: "Criado em",
          minWidth: 250,
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      tipoAbono: {
        id: "",
        descricao: "",
      },
      erros: {
        descricao: "",
      },
    };
  },
  mounted() {
    this.listarAbonos();
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["name", "email"],
      threshold: 0.3,
    });
  },
  methods: {
    notifyVue(verticalAlign, horizontalAlign) {
      this.$notify({
        component: NotificationHorarioLimite,
        icon: "tim-icons icon-bell-55",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "warning",
        timeout: 30000,
      });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    listarAbonos() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/abonos/listarTiposDeAbonos", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.data.dados.length > 0) {
            th.tableData = response.data.data.dados.map((b) => {
              b.dt_criacao = moment(b.dt_criacao).format("DD/MM/YYYY");
              return b;
            });
          } else {
            th.tableData = [];
          }
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Erro ao listar!", "error");
        });
    },

    cadastrarAbono() {
      if (this.validarCampos()) {
        let th = this;
        this.isLoading = true;

        let bodyFormData = {
          setDB: this.$cookies.get("db"),
          descricao: this.descricao,
          ativo: this.ativo ? "S" : "N",
          editavel: "S",
        };

        this.axios
          .post("/api/abonos/criarTipoDeAbonoIndividual", bodyFormData, {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          })
          .then((response) => {
            th.isLoading = false;
            th.dialogTipoAbono = false;
            th.listarAbonos();
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Cadastrado realizado com sucesso!",
              "success",
            );
          })
          .catch((err) => {
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao cadastrar tipo de abono!",
              "error",
            );
          });
      } else {
        this.showSwal(
          "auto-close",
          "Erro",
          "Preencha os campos obrigatórios",
          "error",
        );
      }
    },

    mostrarDialog(tipo, row) {
      this.erros.descricao = "";
      this.dialogTipoAbono = true;
      this.ativo = true;
      this.tipo = tipo;
      this.descricao = "";
      this.tipoAbono = "";

      if (row) {
        this.descricao = row.descricao;
        this.tipoAbono = row;
        this.ativo = row.ativo == "S" ? true : false;
      }
    },

    editarAbono() {
      if (this.validarCampos()) {
        let th = this;
        this.isLoading = true;

        let bodyFormData = {
          setDB: this.$cookies.get("db"),
          id: this.tipoAbono.id,
          descricao: this.descricao,
          editavel: "S",
          ativo: this.ativo ? "S" : "N",
        };

        this.axios
          .post("/api/abonos/atualizarTipoDeAbonoIndividual", bodyFormData, {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          })
          .then((response) => {
            th.isLoading = false;
            th.dialogTipoAbono = false;
            th.listarAbonos();
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Atualizado com sucesso!",
              "success",
            );
          })
          .catch((err) => {
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao atualizar tipo de abono!",
              "error",
            );
          });
      } else {
        this.showSwal(
          "auto-close",
          "Erro",
          "Preencha os campos obrigatórios",
          "error",
        );
      }
    },

    validarCampos() {
      let status = true;
      if (this.descricao === "") {
        this.erros.descricao = true;
        status = false;
      } else {
        this.erros.descricao = false;
      }

      return status;
    },
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
